import React from "react";
import { useOutletContext, useParams } from "react-router";
import { Container } from "../login/styled";
import BusinessJoinForm from "../../login/component/businessJoinForm";

const ShoppingJoin = () => {
  const { url } = useParams();
  const { homepageInfo, theme } = useOutletContext();
  return (
    <Container className={`theme-${theme}`}>
      <BusinessJoinForm homepageInfo={homepageInfo} url={url} />
    </Container>
  );
};

export default ShoppingJoin;
